<template>
  <transition name="slide">
    <div class="auto-wrapper" v-show="show">
      <div class="auto-top-bar">
        <div class="auto-top-inner">
          <input type="text" ref="input" class="auto-control" v-model="keywords" :placeholder="placeholder">
          <button type="button" class="auto-btn" @click.stop="$emit('onCancel')">取消</button>
        </div>
      </div>
      <div class="auto-list-wrapper">
        <scroller ref="scroller">
          <ul class="auto-list">
            <li class="auto-list-item" v-for="(item, index) in list">
              <a @click.stop.prevent="onItemClick(index)">{{item[field]}}</a>
            </li>
          </ul>
        </scroller>
      </div>
    </div>
  </transition>
</template>

<script>
  import Scroller from 'components/scroller/scroller'

  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      placeholder: String,
      delay: {
        type: Number,
        default: 500
      },
      source: {
        type: Array,
        required: true,
        default () {
          return []
        }
      },
      field: {
        type: String,
        default: 'text'
      },
      onSelect: Function
    },
    data () {
      return {
        list: [],
        keywords: ''
      }
    },
    components: {Scroller},
    watch: {
      source (list) {
        this.list = [].concat(list)
      },
      keywords (val) {
        window.clearTimeout(this.timer)
        if (val) {
          this.timer = window.setTimeout(() => {
            this._filterItems()
          }, this.delay)
        } else {
          this.list = [].concat(this.source)
        }
      },
      show (val) {
        this.keywords = ''
        if (val) {
          setTimeout(() => {
            this.$refs.input.focus()
          }, 500)
        }
      }
    },
    methods: {
      _getReg () {
        let result = []
        for (let i = 0, len = this.keywords.length; i < len; i++) {
          result.push(window.escape(this.keywords.charAt(i)).replace(/%/g, '\\'))
        }
        return new RegExp('(' + result.join('') + ')')
      },
      _filterItems () {
        let result = []
        let list = [].concat(this.source)
        let reg = this._getReg()
        list.forEach((item) => {
          if (reg.test(item[this.field])) {
            result.push(item)
          }
        })
        this.list = result
        this.$nextTick(() => {
          if (this.$refs.scroller) {
            setTimeout(() => {
              this.$refs.scroller.resize()
            })
          }
        })
      },
      onItemClick (index) {
        let item = this.list[index]
        this.keywords = ''
        if (typeof this.onSelect === 'function') {
          this.onSelect(item)
          this.$emit('onCancel')
        }
      }
    }
  }
</script>

<style lang="stylus">
  @import '../../common/css/mixmin'

  .auto-wrapper
    position fixed
    top 0
    left 0
    bottom 0
    width 100%
    height 100%
    z-index 3000
    background-color #efeff4
  &.slide-enter-active
    transition all .2s ease-in
  &.slide-leave-active
    transition all .2s ease-out
  &.slide-enter, &.slide-leave-active
    transform translate3d(100%, 0, 0)
    -webkit-transform translate3d(100%, 0, 0)
  .navbar ~ .auto-wrapper, .navbar + .auto-wrapper
    top px2rem(88px)
    height auto
  .auto-top-bar
    padding 5px 0
    box-shadow 0 3px 10px rgba(#abb9c5, .75)
  .auto-top-inner
    display table
    width 98%
    margin-left 1%
    table-layout fixed
    .auto-control, .auto-btn
      display table-cell
    .auto-control
      width 85%
      padding 6px 12px
      font-size px2rem(28px)
      line-height 1.2
      border 1px solid #60c9c8
      border-radius 4px
    .auto-btn
      width 15%
      padding 6px 0
      text-align center
      font-size 16px
      line-height 1
      border none
      background-color transparent
  .auto-list-wrapper
    position absolute
    top 40px
    bottom 0
    left 0
    width 100%
  .auto-list
    margin 0
    padding 0 0 10px
    list-style-type none
    setTopLine(#60c9c8)
  .auto-list-item
    setBottomLine(#60c9c8)
    &>a
      display block
      padding px2rem(12px) px2rem(30px)
      font-size px2rem(28px)
      line-height 1.5
      ellipsis()
</style>



// WEBPACK FOOTER //
// autocomplete.vue?536e1a7f